module.exports = __webpack_public_path__ + "static/AvenirLTStd-Black-1a9f4d3d7532a7c5cfa916cb7d543e6a.otf";